<h2 mat-dialog-title>
  <span class="!text-[#02578E]">{{heading}}</span>
</h2>
@switch (selectedStep) {
@case (1){
<mat-dialog-content class="mat-typography">
  <div class="my-4 h-full">
    <div
      class="flex flex-col w-full px-4 py-4 h-full bg-white border border-[#737791]/30 rounded-md gap-5 overflow-auto">
      <div class="flex flex-col relative gap-2">
        <!-- <label class=" text-sm text-[#000000] font-norma" for="input">Enter AGENT ACCOUNT of Manager you Request a FLOAT
          TRANSFER</label> -->
        <!-- <input class=" w-full h-[48px] rounded-md bg-[#F7F7F7] border border-[#737791]/30" type="text"
          placeholder="eg 2D123456" [(ngModel)]="agentAccount" maxlength="20" pattern="^[0-9]*$"> -->
        <form #agentForm="ngForm">
          <label class=" text-sm text-[#000000] font-norma" for="input">{{'CUSTOMER.ENTER_AGENT_ACCOUNT' | translate}}</label>
          <input class="w-full h-[48px] rounded-md bg-[#F7F7F7] border border-[#737791]/30" type="text"
            placeholder="eg 2D123456" [(ngModel)]="agentAccount" name="agentAccount" #agentAccountRef="ngModel"
            maxlength="20" pattern="^[0-9]*$" required>

          <p class="text-red-500 text-sm mt-1" *ngIf="agentAccountRef.invalid && agentAccountRef.touched">
            {{'CUSTOMER.AGENT_ACCOUNT_REQUIRED' | translate}}
          </p>
        </form>
      </div>
      <div class="flex flex-col relative gap-2">
        <label class=" text-sm text-[#000000] font-norma" for="input">{{'CUSTOMER.ENTER_AMOUNT_TO_RECEIVE' | translate}}</label>
        <div class="flex rounded-md">

          <span
            class="px-4 inline-flex items-center min-w-fit rounded-s-md border border-e-0 border-[#737791]/30 bg-gray-400 text-sm text-white">XAF</span>
          <!-- <input type="text" mask="separator.2" separator=" "
            class="w-full h-[48px] bg-[#F7F7F7] border border-[#737791]/30 rounded-tr-md rounded-br-md"
            placeholder="0000000000" [(ngModel)]="amount"  maxlength="12" pattern="^[0-9]*$"> -->

          <form #amountForm="ngForm" class="w-full">
            <input type="text" mask="separator.2" separator=" "
              class="w-full h-[48px] bg-[#F7F7F7] border border-[#737791]/30 rounded-tr-md rounded-br-md"
              placeholder="0000000000" [(ngModel)]="amount" name="amount" #amountRef="ngModel" maxlength="12"
              pattern="^[0-9]*$" required>

          </form>


        </div>
        <p class="text-red-500 text-sm mt-1" *ngIf="amountRef.invalid && amountRef.touched">
          {{'CUSTOMER.AMOUNT_REQUIRED' | translate}}
        </p>
        <p class="text-red-500 text-sm mt-1" *ngIf="amountRef.valid && amount == '0'">
          {{'CUSTOMER.AMOUNT_GREATER_THAN_ZERO' | translate}}
        </p>
      </div>
    </div>
  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions class="flex flex-wrap justify-end gap-2 md:gap-3" align="end">
  <button class="bg-[#02578E] w-full md:w-[158px] h-[44px] rounded-md text-white" (click)="onCancel()">Cancel</button>
  <button class=" flex justify-center items-center gap-3 bg-[#02578E] w-full  md:w-[158px] h-[44px] rounded-md ms-3"
    (click)="getTellers()" [disabled]="isButtonLoading">
    <img class="animate-spin" *ngIf="isButtonLoading" src="/assets/svgs/loader.svg">
    <span class="text-white text-sm font-normal">Confirm</span>
  </button>
</mat-dialog-actions> -->
<mat-dialog-actions class="flex flex-wrap justify-end gap-2 md:gap-3" align="end">
  <button class="bg-[#02578E] w-full md:w-[158px] h-[44px] rounded-md text-white" (click)="onCancel()">
    {{'COMMON.CANCEL' | translate}}
  </button>
  <button class="flex justify-center items-center gap-2 md:gap-3 bg-[#02578E] w-full md:w-[158px] h-[44px] rounded-md"
    (click)="getTellers()" [disabled]="isButtonLoading">
    <img class="animate-spin" *ngIf="isButtonLoading" src="/assets/svgs/loader.svg">
    <span class="text-white text-sm font-normal">{{'COMMON.CONFIRM' | translate}}</span>
  </button>
</mat-dialog-actions>

} @case (2){
<mat-dialog-content class="mat-typography">
  <div class="my-4 h-full">
    <div class="text-red-500 my-2">{{tellerList.tellerKeyList.length}}{{'CUSTOMER.USER_FOUND' | translate}}</div>
    <div class="flex gap-4 flex-wrap justify-start">
      @for(teller of tellerList.tellerKeyList; track $index){
      <div
        class="flex flex-col sm:w-1/2 lg:w-[48.5%] w-full p-4 bg-white border border-[#737791]/30 rounded-md gap-5 overflow-auto">
        <table class="w-full h-4/5">
          <tbody class="text-[#737791]">
            <tr class=" my-2">
              <td scope="col" class="px-2 py-2  font-medium text-xs">{{'AGENT_TRANSACTIONS.TELLER' | translate}}</td>
              <!-- <td scope="col" class="px-2 py-2  font-medium text-xs">{{teller.id}}</td> -->
              <td scope="col" class="px-2 py-2  font-medium text-xs"> <span
                  class="text-[#0D6EFC]">{{teller.tellerAccess}}</span></td>

            </tr>
            <tr class=" my-2">
              <td scope="col" class="px-2 py-2  font-medium text-xs">{{'SERVICES.AGENT_ACCOUNT' | translate}}</td>
              <td scope="col" class="px-2 py-2  font-medium text-xs">{{teller.agentAccountNo}}</td>
            </tr>
            <tr class=" my-2">
              <td scope="col" class="px-2 py-2  font-medium text-xs">{{'CUSTOMER.USER_INFO' | translate}}</td>
              <td scope="col" class="px-2 py-2  font-medium text-xs"><span
                  class="badge bg-warning text-black">{{teller.lastName}} {{teller.firstName}}</span></td>
            </tr>
            <tr class=" my-2">
              <td scope="col" class="px-2 py-2  font-medium text-xs">{{'CUSTOMER.USER_BRANCH' | translate}}</td>
              <td scope="col" class="px-2 py-2  font-medium text-xs">{{teller.branchName}}</td>
            </tr>
          </tbody>
        </table>
        <table class="w-full">
          <thead class="bg-[#e6eef4]">
            <tr class=" w-full">
              <th scope="col" class="px-2 py-2  text-xs text-[#000000] text-left font-medium rounded-l-sm">
                {{'HOME.PENDING_REQUESTS.AMOUNT' | translate}}</th>
              <th scope="col" class="px-2 py-2 rounded-r-sm font-medium text-xs ">{{amount | priceFormatter}}</th>
            </tr>
          </thead>
          <tbody class="text-[#737791]">
          </tbody>
        </table>
        <div class="text-center">
          <button
            class="flex justify-center items-center bg-[#02578E] w-full md:w-[158px] h-[44px] rounded-md text-white"
            (click)="requestPayment(teller)" [disabled]="isButtonLoading">
            <img class="animate-spin" *ngIf="isButtonLoading" src="/assets/svgs/loader.svg">
            <span class="text-white text-sm font-normal">{{'CUSTOMER.REQUEST_NOW' | translate}}</span>
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</mat-dialog-content>
} @case (3){
<mat-dialog-content class="mat-typography">
  <div class="flex gap-2 bg-blue-100 rounded items-center p-3">
    <div class="rounded-full p-[5px] sm:p-[10px] bg-[#65B065] self-center h-[40px] w-[40px]">
      <img src="/assets/svgs/tickmark.svg" class="w-full h-full">
    </div>
    <span>
      {{'CUSTOMER.SUCCESS_FLOAT_REQUEST' | translate}}
    </span>
  </div>
  <div class="flex flex-col xl:flex-row gap-5 mt-5">
    <div class="w-full xl:w-[50%] bg-white p-4 rounded-md ">
      <h2 class="font-semibold text-base pb-2 text-[#000000]">{{'CUSTOMER.REQUESTER_DETAILS' | translate}}</h2>
      <table class="w-full">
        <tbody class="text-[#737791]">
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'AGENT_TRANSACTIONS.TELLER' | translate}}:</td>
            <td scope="col" class="px-2 py-2  text-xs font-norma">{{requestResponse.applicant.senderTeller}}</td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'CUSTOMER.ACCOUNT' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.applicant.senderRefId}},
              {{requestResponse.applicant.senderBranchName}}</td>
          </tr>
          <tr>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'SERVICES.BRANCH' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.applicant.senderBranchCode}},
              {{requestResponse.applicant.senderBranchName}}</td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'HOME.APPROVED_REQUESTS.AMOUNT_REQUESTED' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.amountProcessed | priceFormatter}}
            </td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">Date:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.transDate | date: 'dd/MM/YYYY'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="w-full xl:w-[50%] bg-white p-4 rounded-md">
      <h2 class=" text-base font-semibold  pb-2 text-[#000000] justify-start">{{'CUSTOMER.APPROVER_DETAIL' | translate}}</h2>
      <table class="w-full">
        <tbody class="text-[#737791]">
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'AGENT_TRANSACTIONS.TELLER' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.approvalAgent.approvalTeller}}</td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'HOME.PENDING_REQUESTS.NAME' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.approvalAgent.approvalAccountName}}
            </td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'CUSTOMER.ACCOUNT' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">
              {{requestResponse.approvalAgent.approvalAccountNumber}},
              {{requestResponse.approvalAgent.approvalAccountBranchName}}</td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{'SERVICES.BRANCH' | translate}}:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">
              {{requestResponse.approvalAgent.approvalAccountBranchCode}},
              {{requestResponse.approvalAgent.approvalAccountBranchName}}</td>
          </tr>
          <tr class=" border-b border-[#E6EFF4] my-2">
            <td scope="col" class="px-2 py-2  text-xs font-normal">Note:</td>
            <td scope="col" class="px-2 py-2 text-xs font-normal">{{requestResponse.remarks}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="text-center">
    <button class="bg-[#02578E] w-full md:w-[138px] h-[44px] rounded-md text-white" (click)="closeDialog()">{{'HOME.PENDING_REQUESTS.OK' | translate}}</button>
  </div>
</mat-dialog-content>
}
}
